module.exports = __webpack_public_path__ + "img/git.3036af48.svg";